<div class="modal fade dialog-modal" tabindex="-1" role="dialog" #dialog>
  <div class="modal-dialog" role="document" [ngClass]="dialogService.classList">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Fechar"
          (click)="close()"
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="icon" [ngClass]="dialogService.iconClass"></div>
        <div class="modal-title" [ngClass]="dialogService.textClass">
          {{ dialogService.title }}
        </div>
      </div>

      <div class="modal-body text-center">
        <p [innerHtml]="dialogService.body"></p>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-sm"
          *ngFor="let button of dialogService.buttons"
          [ngClass]="button.classList"
          (click)="validateAndCall(button.callback)"
        >{{ button.label }}</button>
      </div>
    </div>
  </div>
</div>
